import React, { useState } from "react";
import { supabase } from "../supabase";

function EditGroupModal({ group, isOpen, onClose, onSave }) {
  const [name, setName] = useState(group?.name || "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      if (group) {
        // Update existing group
        const { error } = await supabase
          .from("tv_groups")
          .update({ name })
          .eq("id", group.id);

        if (error) throw error;
      }
      onSave();
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full">
      <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
        <div className="mt-3">
          <h3 className="text-lg font-medium leading-6 text-gray-900 mb-4">
            Edit Group
          </h3>
          <form onSubmit={handleSubmit}>
            {error && (
              <div className="mb-4 bg-red-50 p-4 rounded text-red-600 text-sm">
                {error}
              </div>
            )}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Group Name
              </label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                required
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Upload Video
              </label>
              <input
                type="file"
                accept="video/*"
                onChange={async (e) => {
                  if (e.target.files?.[0]) {
                    const file = e.target.files[0];
                    const fileExt = file.name.split(".").pop();
                    const fileName = `${Math.random()}.${fileExt}`;
                    const filePath = `${group.id}/${fileName}`;

                    // Upload file to Supabase Storage
                    const { error: uploadError } = await supabase.storage
                      .from("slides")
                      .upload(filePath, file);

                    if (uploadError) {
                      setError(uploadError.message);
                      return;
                    }

                    // Update slides_config
                    const { error: configError } = await supabase
                      .from("slides_config")
                      .upsert({
                        group_id: group.id,
                        slides_path: filePath,
                        created_by: group.created_by,
                        updated_at: new Date().toISOString(),
                      });

                    if (configError) {
                      setError(configError.message);
                      return;
                    }
                  }
                }}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              />
            </div>
            <div className="flex justify-end space-x-3">
              <button
                type="button"
                onClick={onClose}
                className="inline-flex justify-center py-2 px-4 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                {loading ? "Saving..." : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EditGroupModal;
